import type { PlatformInterface } from "./platform-interface";
import { PlatformTizen } from "./platform-tizen";
import { PlatformWebOS } from "./platform-webos";
import { PlatformBrowser } from "./platform-browser";
import { PlatformAmazon } from "./platform-amazon";

declare module '#app' {
  interface NuxtApp {
    $platform: PlatformInterface;
  }
}

export default defineNuxtPlugin({
  name: "platform",
  setup: nuxtApp => {
    let platform: PlatformInterface | null = null;

    if(PlatformTizen.matchThisPlatform()) {
        platform = new PlatformTizen();
    } else if(PlatformWebOS.matchThisPlatform()) {
        platform = new PlatformWebOS();
    } else if(PlatformAmazon.matchThisPlatform()) {
        platform = new PlatformAmazon();
    } else {
        platform = new PlatformBrowser();
    }

    nuxtApp.provide('platform', platform);
  }
});

